// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  bugReportId: __t.u64().primaryKey().name("bug_report_id"),
  internalNotes: __t.string().name("internal_notes"),
  lastEditedBy: __t.identity().name("last_edited_by"),
  lastEditedAt: __t.timestamp().name("last_edited_at"),
});
